import React from 'react'
import { createComponent } from '@ycos/fela'

const Arrow = (props) => (
  <SVG {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 48">
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" fillRule="nonzero" d="M16.146 23.354L4.793 12 16.146.646l.708.708L6.207 12l10.647 10.646z" />
    </g>
  </SVG>
)

const SVG = createComponent(
  'SVG',
  ({ theme }) => ({
    boxSizing: 'content-box',
    display: 'inline-block',
    height: `${4 * theme.spacingMultiplier}px`,
    width: `${2 * theme.spacingMultiplier}px`,
    color: theme.typography.colors.PrimaryBlack
  }),
  'svg',
  ['xmlns', 'width', 'height', 'viewBox']
)

const NavigationButton = (props) => (
  <ArrowButton {...props} data-automation={props.dataAutomation} disabled={props.disabled}>
    <Arrow />
  </ArrowButton>
)

const ArrowButton = createComponent(
  'NavigationButton',
  ({ disabled, direction, theme }) => ({
    border: 0,
    cursor: disabled ? 'default' : 'pointer',
    margin: 0,
    paddingTop: 0,
    paddingRight: '8px',
    paddingBottom: 0,
    paddingLeft: 0,
    background: 'none',
    outline: 'none',
    transitionProperty: 'all',
    transitionDuration: theme.custom.animations.slow,
    transform: `scale(${direction === 'left' ? 1 : -1}, 1)`,
    opacity: `${disabled ? 0.4 : 1}`
  }),
  'button'
)

NavigationButton.defaultProps = {
  dataAutomation: 'carousel-next-button',
  disabled: false
}

export default NavigationButton
